'use strict';

export default function (password) {
    // Check password length
    if (password.length < 10) {
        return false;
    }

    // Check that there is at least one lowercase character
    if (password.match(/[a-z]/g) == null) {
        return false;
    }

    // Check that there is at least one uppercase character
    if (password.match(/[A-Z]/g) == null) {
        return false;
    }

    // Check that there is at least one number
    if (password.match(/\d+/g) == null) {
        return false;
    }

    // Check that there is at least two special characters
    if (password.match(/[~`@!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/g).length < 2) {
        return false;
    }

    return true;
}
